import { QueryClient } from '@tanstack/react-query';

// FE-87 phase 1: shared React Query client for ops-dashboard. staleTime keeps cached data
// fresh enough that switching tabs/routes doesn't refire every query; refetchOnWindowFocus
// is off since ops-dashboard agents alt-tab constantly during calls and a refetch storm on
// every focus would be noisy, not helpful.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
